// frontend/src/components/Contacts.js
import React, { useState } from 'react';

function Contacts() {
    const [formData, setFormData] = useState({ email: '', name: '', message: '' });
    const [status, setStatus] = useState({ type: '', message: '' });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: 'loading', message: 'Отправка...' });

        try {
            const response = await fetch('/api/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });
            const data = await response.json();
            if (data.success) {
                setStatus({ type: 'success', message: data.message });
                setFormData({ email: '', name: '', message: '' });
            } else {
                setStatus({ type: 'error', message: 'Ошибка отправки. Попробуйте позже.' });
            }
        } catch (error) {
            console.error('Error:', error);
            setStatus({ type: 'error', message: 'Ошибка сети. Проверьте подключение.' });
        }
    };

    return (
        <div className="t718" style={{ backgroundColor: '#ebebeb', padding: '150px 0' }}>
            <div className="t-container">
                <div className="t-row">
                    <div className="t-col t-col_12">
                        <h2 className="t-section__title t-title t-title_xs t-align_left">Наши контакты</h2>
                    </div>
                </div>
                <div className="t-row">
                    <div className="t-col t-col_6">
                        <div className="t718__contacts t-text t-descr_xxxl">
                            Телефон: +7 (8452) 52-01-01<br />
                            Почта: office@tritec.ru
                        </div>
                        <div className="t718__address t-text t-text_sm">
                            Адрес: г. Саратов, пр-т 50 лет Октября, д. 4/10
                        </div>
                        {/* Соцсети удалены */}
                    </div>
                    <div className="t-col t-col_5 t-offset_1">
                        <form onSubmit={handleSubmit} className="t-form">
                            <div className="t-form__inputsbox">
                                <div className="t-input-group">
                                    <input
                                        type="email"
                                        name="email"
                                        className="t-input"
                                        placeholder="Ваш e-mail"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="t-input-group">
                                    <input
                                        type="text"
                                        name="name"
                                        className="t-input"
                                        placeholder="Ваше имя"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="t-input-group">
                  <textarea
                      name="message"
                      className="t-input"
                      rows="3"
                      placeholder="Ваше сообщение"
                      value={formData.message}
                      onChange={handleChange}
                      required
                  ></textarea>
                                </div>
                                {status.message && (
                                    <div className={`t-form__status ${status.type === 'success' ? 't-form__success' : 't-form__error'}`}>
                                        {status.message}
                                    </div>
                                )}
                                <div className="t-form__submit">
                                    <button type="submit" className="t-submit" disabled={status.type === 'loading'}>
                                        {status.type === 'loading' ? 'Отправка...' : 'Отправить'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contacts;